import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLink } from "uitk-react-link";
import { UitkLayoutGrid } from "uitk-react-layout-grid";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { getFormatTextLocationKey } from "../DestinationCrossLinkUtils";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { DestinationCrossLinkViewProps } from "components/flexComponents/DestinationCrossLink/typings";
import { Destination } from "typings/microserviceModels/destination-cross-link-flex-module";

const ListsView = (props: DestinationCrossLinkViewProps) => {
  const { destinations, geoType } = props;
  const keyHelper = new ItemKeyHelper("cross-link-destination-links");
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGrid columns={{ medium: 2, large: 4 }} space="four">
      {destinations.map((destination: Destination) => (
        <UitkLink inline={true} key={keyHelper.next()}>
          <TrackedLink
            aria-label={formatText(getFormatTextLocationKey(geoType), destination.name)}
            data-testid="destinationCardLink"
            moduleName="destinationCrossLink"
            rfrr="link-destination"
            href={destination.url}
          >
            {destination.name}
          </TrackedLink>
        </UitkLink>
      ))}
    </UitkLayoutGrid>
  );
};

export default ListsView;
